import { HeaderMenus as HeaderMenusFR } from './header';
import { FooterMenu as FooterMenuFR, FooterCopyRightLinks as FooterCopyRightLinksFR } from './footer';
import { GlobalNavigationConfig } from '../../../entities';

export const FranceConfig: GlobalNavigationConfig = {
  footerVariant: 'simple',
  headerVariant: 'simple',
  logoVariant: 'france',
  menu: {
    copyright: FooterCopyRightLinksFR,
    footer: FooterMenuFR,
    header: HeaderMenusFR,
  },
};
